import { put, takeLatest } from "redux-saga/effects";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
} from "shared-utility/store/utils/helpers";

// supplemental

// ACTIONS

/*
 * NOTE: This was not being used
 * export const SUPPLEMENTAL_CALCULATOR_RESET_TEST_DATA = generateDefaultActions("SUPPLEMENTAL_CALCULATOR_RESET_TEST_DATA");
 * export const supplementalCalculatorResetTestData = payload => makePayload(SUPPLEMENTAL_CALCULATOR_RESET_TEST_DATA.value, payload);
 * function* supplementalCalculatorResetTestDataSaga(payload) {
 *   yield put(SUPPLEMENTAL_CALCULATOR_RESET_TEST_DATA);
 * }
 */

export const SUPPLEMENTAL_CALCULATOR_GET_INFO = generateDefaultActions("SUPPLEMENTAL_CALCULATOR_GET_INFO");
export const getSupCalcInfo = payload => makePayload(SUPPLEMENTAL_CALCULATOR_GET_INFO.value, payload);
function* getSupCalcInfoSaga(payload) {
  const url = "/supplementalCalcSettings";
  yield requestSaga(SUPPLEMENTAL_CALCULATOR_GET_INFO, url, "POST", payload);
}

// SUPPLEMENTAL_CALCULATOR_CALCULATING
export const SUPPLEMENTAL_CALCULATOR_CALCULATING = generateDefaultActions("SUPPLEMENTAL_CALCULATOR_CALCULATING");
export const calculateSuppPricerCalculating = payload => makePayload(SUPPLEMENTAL_CALCULATOR_CALCULATING.value, payload);
function* calculateSuppPricerCalculatingSaga(payload) {
  yield put(SUPPLEMENTAL_CALCULATOR_CALCULATING.createSuccess(payload));
}

// SUPPLEMENTAL_CALCULATOR_CALCULATE
export const SUPPLEMENTAL_CALCULATOR_CALCULATE = generateDefaultActions("SUPPLEMENTAL_CALCULATOR_CALCULATE");
export const calculateSuppPricer = payload => makePayload(SUPPLEMENTAL_CALCULATOR_CALCULATE.value, payload);
function* calculateSuppPricerSaga(payload) {
  const url = "/dealSuppPricer";
  try {
    yield put(SUPPLEMENTAL_CALCULATOR_CALCULATING.createSuccess({ isCalculating: true }));
    yield requestSaga(SUPPLEMENTAL_CALCULATOR_CALCULATE, url, "POST", payload);
  } finally {
    yield put(SUPPLEMENTAL_CALCULATOR_CALCULATING.createSuccess({ isCalculating: false }));
  }
}

// REDUCER

const initialState = {
  tiers: null,
  tierValues: null,
  calculationConfigItems: null,
  creditGuidanceValues: null,
  isCalculating: null,
  result: null
};

export function supplementalCalculatorReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    /*
     * NOTE: This was not being used
     * case SUPPLEMENTAL_CALCULATOR_RESET_TEST_DATA:
     *   return { ...state, ...initialState };
     */

    case SUPPLEMENTAL_CALCULATOR_GET_INFO.success:
      const { tiers, tierValues, calculationConfigItems, creditGuidanceValues } = payload.results;

      return {
        ...state,
        tiers,
        tierValues,
        calculationConfigItems,
        creditGuidanceValues
      };

    case SUPPLEMENTAL_CALCULATOR_CALCULATING.success:
      return { ...state, ...payload };

    case SUPPLEMENTAL_CALCULATOR_CALCULATE.success:
      return defaultReturn(state, payload, "result");

    default:
      return state;
  }
}

// SAGA

export function* supplementalCalculatorSaga() {
  yield takeLatest(SUPPLEMENTAL_CALCULATOR_GET_INFO.value, getSupCalcInfoSaga);
  yield takeLatest(SUPPLEMENTAL_CALCULATOR_CALCULATE.value, calculateSuppPricerSaga);
  yield takeLatest(SUPPLEMENTAL_CALCULATOR_CALCULATING.value, calculateSuppPricerCalculatingSaga);
}
